import { render, staticRenderFns } from "./InvestmentRiskResult.vue?vue&type=template&id=32bd3c78&scoped=true&"
import script from "./InvestmentRiskResult.vue?vue&type=script&lang=js&"
export * from "./InvestmentRiskResult.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentRiskResult.vue?vue&type=style&index=0&id=32bd3c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd3c78",
  null
  
)

export default component.exports